import account from "./account.json";
import auth from "./auth.json";
import business from "./business.json";
import chat from "./chat.json";
import common from "./common.json";
import customization from "./customization.json";
import dealership from "./dealership.json";
import deathScreen from "./deathScreen.json";
import errors from "./errors.json";
import estate from "./estate.json";
import faction from "./faction.json";
import gasStation from "./gasStation.json";
import hotel from "./hotel.json";
import hud from "./hud.json";
import inventory from "./inventory.json";
import notification from "./notification.json";
import notifications from "./notifications.json";
import offer from "./offer.json";
import ped from "./ped.json";
import phone from "./phone.json";
import playerMenu from "./playerMenu.json";
import shop from "./shop.json";
import spawn from "./spawn.json";
import tablet from "./tablet.json";
import targetMenu from "./targetMenu.json";
import transportWarehouse from "./transportWarehouse.json";
import validation from "./validation.json";
import vehicle from "./vehicle.json";

export default {
  account,
  auth,
  business,
  chat,
  common,
  customization,
  deathScreen,
  errors,
  estate,
  faction,
  gasStation,
  hotel,
  hud,
  inventory,
  notification,
  notifications,
  offer,
  shop,
  spawn,
  tablet,
  targetMenu,
  validation,
  vehicle,
  phone,
  playerMenu,
  ped,
  dealership,
  transportWarehouse,
};
